import { ClubDenormalized } from './club.model';
import { TechSync } from './device-sync.model';
import { SquadDenormalized } from './squad.model';
import { TeamDenormalized } from './team.model';

export class Tech {    
    id: string;    
    name: string;      
    squads?: any;
    teams?: any;
    _squads?: SquadDenormalized[];   
    _teams?: TeamDenormalized[];
    syncs?: TechSync[];
    send_invitation?: boolean;
    socialmedia?: any;
    user?: any;
    _deleted?: boolean;
    photo_url?: string;
    phone?: string;
    first_name: string;
    last_name?: string;
    club: ClubDenormalized;
    display_name?: string;

    birth_date?: string;
    gender?: string;
    email?: string;
    job?: string; 
    job_name?: string;
    
    confirmation?: {
        token: string;
        expiredAt: string;
        tech: string;
        id_team: string;
        id_club: string;
        club: string;
        created: string;
        confirmed: boolean;
        job: string;
        job_name?: string;
        shield?: string;
    }
}

export interface TechDenormalized {
    id: string;    
    job?: string; 
    first_name: string;
    last_name?: string;    
}

export function completeTech(tech: Tech) {
    tech._squads = [];
    tech._teams = [];
    if(tech.squads) {        
        for (let value of Object.values(tech.squads)) {   
            tech._squads.push(value as SquadDenormalized);
        }
    }
    if(tech.teams) {        
        for (let value of Object.values(tech.teams)) {   
            tech._teams.push(value as TeamDenormalized);
        }
    }
}